module.exports = __webpack_public_path__ + "static/img/company-component-coveEn-10-1.3b235547.jpg";